export default class Menu {
  constructor(node) {
    this.node = node

    this.body = document.querySelector('body')
    // this.buttonBurger = this.node.querySelector('.header-open-close-btn')
    // this.buttonClose = this.node.querySelector('.hamburger-container')

    this.prevScrollpos = window.scrollY

    // this.clickOpenClose = this.clickOpenClose.bind(this)
    this.scrollShowHide = this.scrollShowHide.bind(this)

    this.init()
  }

  init() {
    console.debug('  -> Menu init')
    this.reset()
    this.addListeners()
    if (window.scrollY > 0) {
      this.node.style.top = '-125px'
    }
  }

  addListeners() {
    // this.buttonBurger.addEventListener('click', this.clickOpenClose)
    window.addEventListener('scroll', this.scrollShowHide)
  }

  // clickOpenClose(e) {
  //   e.preventDefault()
  //   // console.log('Body: ', this.body)
  //   if (this.node.classList.contains('open')) {
  //     this.node.classList.remove('open')
  //     this.node.classList.add('close')
  //     this.body.classList.remove('overflow-hidden')

  //     if (window.scrollY !== 0) {
  //       this.node.classList.add('shadow')
  //     }
  //   } else {
  //     this.node.classList.add('open')
  //     this.node.classList.remove('close')
  //     this.node.classList.remove('shadow')
  //     this.body.classList.add('overflow-hidden')
  //   }
  // }

  scrollShowHide() {
    var currentScrollPos = window.scrollY
    if (!this.node.classList.contains('open')) {
      if (this.prevScrollpos > currentScrollPos) {
        if (currentScrollPos <= 0) {
          this.node.classList.remove('shadow')
        } else {
          if (!this.node.classList.contains('shadow')) {
            this.node.classList.add('shadow')
          }
        }

        this.node.style.top = '0'
      } else {
        if (currentScrollPos > 0) this.node.style.top = '-125px'
      }

      // TODO: refactoring con classi + css transform translate

      this.prevScrollpos = currentScrollPos
    }
  }

  reset() {
    console.debug('  -> Menu reset')

    this.node.classList.remove('open')
  }

  static destroy() {
    console.debug('  -> Menu destroy')

    this.reset()

    // this.buttonBurger.removeEventListener('click', this.clickOpen)
    // this.buttonClose.removeEventListener('click', this.clickClose)
  }

  static init() {
    console.debug('== Menu component ==')
    Menu.item = new Menu(document.querySelector('.header'))
  }
}
